import {request} from '../utils/axios'

/* 登录 */
export function handleLogins(data) {
  return request({
    url: '/api/Login/Login',
    method: 'post',
    data
  })
}

/* 修改密码 */
export function updatePassword(data) {
  return ({
    url: '',
    method: 'post',
    data
  })
}

/* 大平台直接登录 */
export function handleForceLogin(data) {
  return request({
    url: '/api/Login/IntoIndex',
    method: 'post',
    data
  })
}

/* 完善信息提交登录 */
export function handlePerfectLogin(data) {
  return request({
    url: '/api/Login/PerfectInfo',
    method: 'post',
    data
  })
}

/* 注册 区/县数据 */
export function getCountyData() {
  return request({
    url: '/api/Login/SelProvince',
    method: 'get'
  })
}

/* 注册 获取所属街道/社区/小区数据 */
export function getRegisStreetData(params) {
  return request ({
    url: '/api/Login/SelAllInfo',
    method: 'get',
    params
  })
}

/* 注册处理 */
export function handleRegister(data) {
  return request ({
    url: '/api/Login/AddInfo',
    method: 'post',
    data
  })
}

/* 忘记密码 找回 */
export function retrievePwd(data) {
  return request ({
    url: '/api/Login/ForGetPwd',
    method: 'post',
    data
  })
}

/* 修改信息 */
/* 修改密码 */
export function handleUptatePwd(data) {
  return request ({
    url: '/api/Login/Pwd',
    method: 'post',
    data
  })
}
/* 修改我的身份 */
export function handleUptateIndenti(data) {
  return request ({
    url: '/api/Login/UpdStatus',
    method: 'post',
    data
  })
}
/* 修改我的小区 */
export function handleUpdatePlace(data) {
  return request ({
    url: '/api/Login/UpdInfo',
    method: 'post',
    data
  })
}

/* 获取乡镇数据 */
export function getTownshipData() {
  return request ({
    url: '/api/Login/Township',
    method: 'get'
  })
}

/* 所属村 */
export function getVillageData(params) {
  return request ({
    url: '/api/Login/Village',
    method: 'get',
    params
  })
}

/* 一集党组织数据 */
export function getPartyOrgan() {
  return request ({
    url: '/api/Login/OneParty',
    method: 'get'
  })
}
/* 二集党组织数据 */
export function getPartyOrganTwo(params) {
  return request ({
    url: '/api/Login/TwoParty',
    method: 'get',
    params
  })
}
/* 三集党组织数据 */
export function getPartyOrganThree(params) {
  return request ({
    url: '/api/Login/ThreeParty',
    method: 'get',
    params
  })
}
/* 四集党组织数据 */
export function getPartyOrganFour(params) {
  return request ({
    url: '/api/Login/FourParty',
    method: 'get',
    params
  })
}

/* 一键注册智慧党建平台账号 */
export function hanldeRegisOneKey(data) {
  return request ({
    url: '/api/Login/RegistInfo',
    method: 'post',
    data
  })
}

/* 获取个人信息 */
export function getProfileMsg(params) {
  return request({
    url: '/api/Login/QueryInfo',
    method: 'get',
    params
  })
}

/* 上传活动凭证 */
export function activityInfos(data) {
  return request ({
    url: '/api/MyActivity/ActivityInfos',
    method: 'get',
    params: data
  })
}
